import ic_3_dots from './ic_3_dots.svg';
import ic_box from './ic_box.svg';
import ic_buildings from './ic_buildings.svg';
import ic_cards from './ic_cards.svg';
import ic_document_copy from './ic_document-copy.svg';
import ic_element_1 from './ic_element-1.svg';
import ic_flash from './ic_flash.svg';
import ic_flash_v2 from './ic_flash_v2.svg';
import ic_global_2 from './ic_global-2.svg';
import ic_global from './ic_global.svg';
import ic_graphic_discord from './ic_graphic_discord.webp';
import ic_keyboard_arrow_down from './ic_keyboard_arrow_down.svg';
import ic_lfg from './ic_lfg.png';
import ic_link from './ic_link.svg';
import ic_link_v2 from './ic_link_v2.svg';
import ic_minus from './ic_minus.svg';
import ic_ocean from './ic_ocean.svg';
import ic_our_vision from './ic_our_vision.svg';
import ic_people from './ic_people.svg';
import ic_people_v2 from './ic_people_v2.svg';
import ic_plus from './ic_plus.svg';
import ic_profile_2user from './ic_profile-2user.svg';
import ic_receipt_2 from './ic_receipt-2.svg';
import ic_search from './ic_search.svg';
import ic_shapes from './ic_shapes.svg';
import ic_shield_tick from './ic_shield-tick.svg';
import ic_status_up from './ic_status_up.svg';
import ic_tag from './ic_tag.svg';
import ic_wave_section from './ic_wave_section.svg';
import ic_wave_section_2 from './ic_wave_section_2.svg';
import ic_x from './ic_x.svg';

export const icons = {
  ic_box,
  ic_cards,
  ic_flash,
  ic_graphic_discord: ic_graphic_discord.src,
  ic_keyboard_arrow_down,
  ic_lfg: ic_lfg.src,
  ic_link,
  ic_minus,
  ic_ocean,
  ic_people,
  ic_plus,
  ic_search,
  ic_shapes,
  ic_status_up,
  ic_tag,
  ic_wave_section,
  ic_3_dots,
  ic_x,
  // Version 2 icons
  ic_flash_v2,
  ic_link_v2,
  ic_people_v2,
  ic_wave_section_2,
  ic_our_vision,
  // Orbit icons
  ic_element_1,
  ic_receipt_2,
  ic_global,
  ic_buildings,
  ic_document_copy,
  ic_shield_tick,
  ic_global_2,
  ic_profile_2user,
};

export * from './HighLightHorizontal';
